import pigletAdditionApi from '@/api/piglet/pigletDeliveryAdditionApi';

export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async fetch(_, {context}) {
      try {
        const response = await pigletAdditionApi.fetch(context);
        return Promise.resolve(response.data);
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async fetchDefault(_, form) {
      try {
        const response = await pigletAdditionApi.fetchDefaultAdditions(form);
        return Promise.resolve(response.data);
      } catch(error) {
        return await Promise.reject(error);
      }
    }
  }
}
